
const data = {
	dossiers: {
		preparation: {
			nom: 'Préparation',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		mairie: {
			nom: 'Mairie',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/3%20-%20Mairie/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/3%20-%20Mairie/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		exterieur: {
			nom: 'Exterieur',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/4%20-%20Exterieur/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/4%20-%20Exterieur/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		ceremonie: {
			nom: 'Cérémonie',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/5%20-%20C%c3%a9r%c3%a9monie/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/5%20-%20C%c3%a9r%c3%a9monie/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		photos_de_groupes: {
			nom: 'Photos de groupes',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/6%20-%20Photos%20de%20groupe/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/6%20-%20Photos%20de%20groupe/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		exterieur_2: {
			nom: 'Exterieur (suite)',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/7%20-%20Exterieur%202/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/7%20-%20Exterieur%202/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		interieur: {
			nom: 'Interieur',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/8%20-%20Interieur/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/8%20-%20Interieur/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		marine_et_jonas: {
			nom: 'Marine et Jonas',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/9%20-%20Photos%20couple/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/9%20-%20Photos%20couple/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		divers: {
			nom: 'Divers',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/10%20-%20Divers/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/10%20-%20Divers/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		discours: {
			nom: 'Discours',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/11%20-%20Discours/?r=site/json&noteMin=4',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/11%20-%20Discours/?r=site/zip&noteMin=4',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		danse: {
			nom: 'Danse',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/12%20-%20Danse/?r=site/json',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/12%20-%20Danse/?r=site/zip',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
		lendemain: {
			nom: 'Lendemain',
			url: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/13%20-%20Lendemain/?r=site/json',
			zip: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/13%20-%20Lendemain/?r=site/zip',
			images: [
				{
					thumbs: 'https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/1%20-%20Pr%C3%A9paratifs/?r=picture/thumbs&img=IMG_1790.JPG',
				}
			],
			loaded: false,
		},
	}
};

export default data



// WEBPACK FOOTER //
// ./src/photos.js